import { render } from "./BasicTemplate.vue?vue&type=template&id=4548be72&scoped=true"
import script from "./BasicTemplate.vue?vue&type=script&lang=js"
export * from "./BasicTemplate.vue?vue&type=script&lang=js"

import "./BasicTemplate.vue?vue&type=style&index=0&id=4548be72&scoped=true&lang=css"

import exportComponent from "C:\\onetap\\onetap\\frontend\\onetapuser\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4548be72"]])

export default __exports__